import SimpleArtist from '../../../../../common/types/artist/simple-artist';
import { Collaborator } from '../../../../../services/collaborator/types/collaborator';
import { NewCollaborator } from '../../../../../services/collaborator/types/new-collaborator';

export const collaboratorAsArtist = (
  collaborator: Collaborator | NewCollaborator
): SimpleArtist => {
  return {
    id: collaborator.collaboratorId as string,
    name: collaborator.name || '',
    avatar: '',
    shortId: '',
    type: 'solo',
    created_at:
      'created_at' in collaborator
        ? new Date(collaborator.created_at)
        : new Date(),
    updated_at:
      'updated_at' in collaborator
        ? new Date(collaborator.updated_at)
        : new Date(),
  };
};
